module.exports = __webpack_public_path__ + "img/i-seat-care.6939cc78.svg";